import { AppConfigModel } from '@app/models/app-config.model';

export const environment: Partial<AppConfigModel> = {
  APP_ID: 8,
  BASE_HREF: '/',
  API_PROTOCOL: 'https',
  DEFAULT_NOTIFICATION_DURATION: 4000,
  PRODUCTION: true,
};
